/* eslint-disable no-case-declarations */
import actions from "./actions";

const {
  LIST_QRCODES_BEGIN,
  LIST_QRCODES_SUCCESS,
  LIST_QRCODES_ERR,

  CREATE_QRCODE_BEGIN,
  CREATE_QRCODE_SUCCESS,
  CREATE_QRCODE_ERR,

  UPDATE_QRCODE_BEGIN,
  UPDATE_QRCODE_SUCCESS,
  UPDATE_QRCODE_ERR,

  DELETE_QRCODE_BEGIN,
  DELETE_QRCODE_SUCCESS,
  DELETE_QRCODE_ERR,

  BLOCK_QRCODE_BEGIN,
  BLOCK_QRCODE_SUCCESS,
  BLOCK_QRCODE_ERR,

  UNBLOCK_QRCODE_BEGIN,
  UNBLOCK_QRCODE_SUCCESS,
  UNBLOCK_QRCODE_ERR,

  GET_QRCODE_DETAILS_BEGIN,
  GET_QRCODE_DETAILS_SUCCESS,
  GET_QRCODE_DETAILS_ERR,
} = actions;

const initState = {
  loadingCreateQRCode: false,
  errorCreateQRCode: "",
  loadingUpdateQRCode: false,
  errorUpdateQRCode: "",
  qrcodes: [],
  totalQRCodes: 0,
  totalQRCodesPages: 0,
  loadingDeleteQRCode: false,
  errorDeleteQRCode: "",
  loadingBlockQRCode: false,
  errorBlockQRCode: null,
  loadingUnblockQRCode: false,
  errorUnblockQRCode: null,
  loadingGetQRCodeDetails: false,
  errorGetQRCodeDetails: null,
  qrcodeDetails: {},
};

const qrcodesReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CREATE_QRCODE_BEGIN:
      return {
        ...state,
        loadingCreateQRCode: true,
        errorCreateQRCode: "",
      };
    case CREATE_QRCODE_SUCCESS:
      return {
        ...state,
        qrcodes: [...state.qrcodes, data],
        loadingCreateQRCode: false,
        errorCreateQRCode: "",
      };
    case CREATE_QRCODE_ERR:
      return {
        ...state,
        errorCreateQRCode: err,
        loadingCreateQRCode: false,
      };

    case LIST_QRCODES_BEGIN:
      return {
        ...state,
        loadingListQRCodes: true,
        errorListQRCodes: false,
        totalQRCodes: 0,
        totalQRCodesPages: 0,
      };
    case LIST_QRCODES_SUCCESS:
      return {
        ...state,
        qrcodes: [...data.results],
        loadingListQRCodes: false,
        errorListQRCodes: null,
        totalQRCodes: data.total_count,
        totalQRCodesPages: data.total_pages,
      };
    case LIST_QRCODES_ERR:
      return {
        ...state,
        errorListQRCodes: err,
        loadingListQRCodes: false,
        totalQRCodes: 0,
        totalQRCodesPages: 0,
      };

    case UPDATE_QRCODE_BEGIN:
      return {
        ...state,
        loadingUpdateQRCode: true,
        errorUpdateQRCode: false,
      };
    case UPDATE_QRCODE_SUCCESS:
      const updatedQRCodes = state.qrcodes.map((qrcode) =>
        qrcode.id === data.id ? { ...qrcode, ...data } : qrcode
      );
      return {
        ...state,
        qrcodes: updatedQRCodes,
        loadingUpdateQRCode: false,
        errorUpdateQRCode: null,
      };
    case UPDATE_QRCODE_ERR:
      return {
        ...state,
        errorUpdateQRCode: err,
        loadingUpdateQRCode: false,
      };

    case DELETE_QRCODE_BEGIN:
      return {
        ...state,
        loadingDeleteQRCode: true,
        errorDeleteQRCode: null,
      };
    case DELETE_QRCODE_SUCCESS:
      return {
        ...state,
        qrcodes: state.qrcodes.filter((qrcode) => qrcode.id !== data.id),
        loadingDeleteQRCode: false,
        errorDeleteQRCode: null,
      };
    case DELETE_QRCODE_ERR:
      return {
        ...state,
        errorDeleteQRCode: err,
        loadingDeleteQRCode: false,
      };

    case BLOCK_QRCODE_BEGIN:
      return {
        ...state,
        loadingBlockQRCode: true,
        errorBlockQRCode: null,
      };
    case BLOCK_QRCODE_SUCCESS:
      return {
        ...state,
        loadingBlockQRCode: false,
        errorBlockQRCode: null,
      };
    case BLOCK_QRCODE_ERR:
      return {
        ...state,
        errorBlockQRCode: err,
        loadingBlockQRCode: false,
      };

    case UNBLOCK_QRCODE_BEGIN:
      return {
        ...state,
        loadingUnblockQRCode: true,
        errorUnblockQRCode: null,
      };
    case UNBLOCK_QRCODE_SUCCESS:
      return {
        ...state,
        loadingUnblockQRCode: false,
        errorUnblockQRCode: null,
      };
    case UNBLOCK_QRCODE_ERR:
      return {
        ...state,
        loadingUnblockQRCode: false,
        errorUnblockQRCode: err,
      };

    case GET_QRCODE_DETAILS_BEGIN:
      return {
        ...state,
        qrcodeDetails: {},
        loadingGetQRCodeDetails: true,
        errorGetQRCodeDetails: null,
      };
    case GET_QRCODE_DETAILS_SUCCESS:
      return {
        ...state,
        qrcodeDetails: data,
        loadingGetQRCodeDetails: false,
        errorGetQRCodeDetails: null,
      };
    case GET_QRCODE_DETAILS_ERR:
      return {
        ...state,
        qrcodeDetails: {},
        loadingGetQRCodeDetails: false,
        errorGetQRCodeDetails: err,
      };

    default:
      return state;
  }
};

export { qrcodesReducer };
